<template lang="pug">
  dv-form(
    :schema="schema"
    :nestable="false"
    :value="{ correctOptions }"
    v-slot="{ fields, formData }"
  )
    v-row
      v-col(cols="12")
        dv-form-field(
          :field="fields.correctOption"
        )
          v-row
            v-col(
              v-for="(option, idx) in options"
              :key="option.id"
              cols="12"
            )
              component(
                v-bind="props"
                :is="component"
                :value="option"
                :can-delete="options.length > defaultOptionsLength"
                @input="(val) => updateOption(idx, val)"
                @delete="() => deleteOption(idx)"
              )
                template(
                  v-if="selectedCorrect"
                  v-slot:prepend
                )
                  dv-checkbox(
                    :off-icon="multiple ? '$ui-checkbox-off' : '$ui-radio-off'"
                    :on-icon="multiple ? '$ui-checkbox-on' : '$ui-radio-on'"
                    :input-value="option.is_correct"
                    hide-details
                    @input="(val) => setCorrectOption(idx, val)"
                  )

      v-col.py-2(
        v-if="maxSumCorrectOptionsScore"
        cols="12"
      )
        dv-alert.px-0.py-0(
          text
          no-tonal
          type="info"
          color="ui-primary"
        )
          span За этот вопрос можно получить {{ multiple ? 'от 0 до' : 'максимум' }}
          span &nbsp;{{ maxSumCorrectOptionsScore }} баллов

    v-row
      v-col(cols="12")
        dv-input(
          v-model="options"
          v-bind="$attrs"
          hide-details="auto"
        )
          .d-flex.mb-2
            dv-btn(
              large
              color="ui-primary lighten-4"
              @click="() => addOption()"
            )
              v-icon.mr-2(size="20" color="ui-primary") $ui-plus
              p.ui-primary--text {{ createText }}
</template>

<script>
import DvInputGroup from '@/packages/ui/components/inputs/DvInputGroup.vue';
import DvTextField from '@/packages/ui/components/inputs/DvTextField.vue';
import DvCheckbox from '@/packages/ui/components/inputs/DvCheckbox.vue';
import DvFormField from '@/packages/ui/components/forms/DvFormField.vue';
import DvAlert from '@/packages/ui/components/alerts/DvAlert.vue';
import DvInput from '@/packages/ui/components/inputs/DvInput.vue';
import DvForm from '@/packages/ui/components/forms/DvForm.vue';
import DvBtn from '@/packages/ui/components/buttons/DvBtn.vue';

import AnswerOption from '@/models/list/answer/option/index.js';

export default {
  components: {
    DvTextField,
    DvFormField,
    DvCheckbox,
    DvInput,
    DvAlert,
    DvForm,
    DvBtn,
  },
  props: {
    component: {
      type: [String, Object],
      required: true,
    },
    props: {
      type: Object,
      default: () => ({}),
    },
    defaultOptionsLength: {
      type: Number,
      default: 2,
    },
    createText: {
      type: String,
      default: 'Добавить вариант ответа',
    },
    selectedCorrect: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    score: {
      type: [String, Number],
      default: undefined,
    },
    value: {
      type: Array,
      default: undefined,
    },
  },
  data() {
    return {
      options: this.value,
    };
  },
  watch: {
    value: {
      handler(val) {
        this.options = val;

        if (!val?.length) this.initOptions();
      },
      immediate: true,
    },
    options: {
      handler(val) {
        this.$emit('input', val);
      },
    },
    score(val) {
      this.options.forEach((option) => {
        this.$set(option, 'score', val);
      });
    },
    multiple(val) {
      if (!val) {
        this.correctOptions.forEach((option, idx) => {
          this.$set(option, 'is_correct', idx === 0);
        });
      }

      this.options.forEach((option) => {
        this.$set(option, 'score', this.score);
      });
    },
    selectedCorrect(val) {
      if (!val) {
        this.correctOptions.forEach((option) => {
          this.$set(option, 'is_correct', false);
        });
      }
    },
  },
  computed: {
    schema() {
      const { selectedCorrect, multiple } = this;

      return [
        {
          name: 'correctOption',
          value: 'correctOptions',
          rules: selectedCorrect ? `required_select:${multiple ? '2' : '1'},some` : undefined,
          component: DvInputGroup,
        },
      ];
    },
    correctOptions() {
      return this.options.filter((i) => i.is_correct);
    },
    maxSumCorrectOptionsScore() {
      return [...this.correctOptions || []]
        .reduce((acc, i) => (
          acc + (i.score || 0)
        ), 0);
    },
  },
  methods: {
    getDefaultOptions(length = this.defaultOptionsLength) {
      return Array.from(
        { length },
        () => new AnswerOption(),
      );
    },
    initOptions() {
      const { options, getDefaultOptions } = this;

      if (!Array.isArray(options)) {
        this.options = [];
      }

      const newOptions = getDefaultOptions();
      this.options.push(...newOptions);
    },
    addOption() {
      const { score } = this;

      this.options.push(new AnswerOption({
        score,
      }));
    },
    updateOption(idx, val) {
      const { options } = this;
      this.$set(options, idx, val);
    },
    setCorrectOption(idx, val) {
      const { correctOptions, multiple, options } = this;
      const option = options[idx];

      if (!!correctOptions.length && !multiple) {
        const [oldOption] = correctOptions;
        this.$set(oldOption, 'is_correct', false);
      }

      this.$set(option, 'is_correct', val);
    },
    deleteOption(idx) {
      this.options.splice(idx, 1);
    },
  },
};
</script>
